import { render, staticRenderFns } from "./SynatecModalAuto.vue?vue&type=template&id=979ffee4&"
import script from "./SynatecModalAuto.vue?vue&type=script&lang=js&"
export * from "./SynatecModalAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports